import { Grid, Skeleton } from '@mui/material';
import { QuickLinkCircle } from './QuickLinkCircle';

export const LoadingSkeleton = () => (
  <Grid
    data-testid="quick-links-loading-skeleton"
    size={1}
    sx={{
      display: 'flex',
      flexDirection: { xs: 'row', md: 'column' },
      alignItems: 'center',
      gap: 1,
      py: 1,
      px: { xs: 0.5, sm: 2 },
    }}
  >
    <QuickLinkCircle>
      <Skeleton variant="circular" sx={{ height: '100%', width: '100%' }} />
    </QuickLinkCircle>
    <Skeleton variant="text" sx={{ width: '50%' }} />
  </Grid>
);
